/* eslint-disable */
import * as EZUIKitModule from 'ezuikit-js'

export function ensureEZUIKit () {
  if (!window.EZUIKit || Object.keys(window.EZUIKit).length === 0) {
    if (EZUIKitModule?.default) {
      window.EZUIKit = EZUIKitModule.default
    } else if (EZUIKitModule?.EZUIKitPlayer) {
      window.EZUIKit = {
        EZUIKitPlayer: EZUIKitModule.EZUIKitPlayer,
        HLS: EZUIKitModule.HLS,
        FLV: EZUIKitModule.FLV
      }
    }
  }
}

/**
 * @returns {typeof window.EZUIKit.EZUIKitPlayer | null}
 */
export function getEZUIKitPlayerClass () {
  ensureEZUIKit()
  if (window.EZUIKit?.EZUIKitPlayer) {
    return window.EZUIKit.EZUIKitPlayer
  }
  if (EZUIKitModule?.default?.EZUIKitPlayer) {
    if (!window.EZUIKit) window.EZUIKit = EZUIKitModule.default
    return EZUIKitModule.default.EZUIKitPlayer
  }
  if (EZUIKitModule?.EZUIKitPlayer) {
    if (!window.EZUIKit) {
      window.EZUIKit = {
        EZUIKitPlayer: EZUIKitModule.EZUIKitPlayer,
        HLS: EZUIKitModule.HLS,
        FLV: EZUIKitModule.FLV
      }
    }
    return EZUIKitModule.EZUIKitPlayer
  }
  return null
}
